import store from '@/store'
export default (to, from, next) => {
  /*validateSession().then(async (token) => {        
    if (token) {
      return next()
    } else {      
      next({name: 'auth'})
    }
  })*/
}



// WEBPACK FOOTER //
// ./src/router/middleware/app.js